import ApiService from '@/services/api.service.js';

export const UserRoles = {
  ADMIN: 'ADMIN',
  REGIONAL_ADMIN: 'REGIONAL_ADMIN',
  AUDITOR: 'AUDITOR',
  APPLICANT: 'APPLICANT',
  EVALUATOR: 'EVALUATOR'
};

export const UserService = {

  getAuthUser: function () {
    return ApiService.get('/auth/user');
  },

  getToken: function (userId) {
    return ApiService.get('/user/get-token/' + userId);
  },

  getProfileData: function () {
    return ApiService.get('/user/profileData');
  },

  createNewUser: function (data) {
    return ApiService.post('/user/create', data);
  },

  getUserProfileData: function (userId) {
    return ApiService.get('/user/profileData/' + userId);
  },

  updateProfileData: function (data) {
    return ApiService.post('/user/profileData', data);
  },

  updateUserProfileData: function (data, userId) {
    return ApiService.post('/user/profileData/' + userId, data);
  },

  setLanguage: function (language) {
    return ApiService.post('/user/language', {
      language: language
    });
  },

  changePassword: function (data) {
    return ApiService.post('/user/changePassword', data);
  },

  setNewPassword: function (data) {
    return ApiService.post('/user/setNewPassword', data);
  },

  getUsers: function () {
    return ApiService.get('/users');
  },

  deleteUser: function (data) {
    return ApiService.post('/user/delete', data);
  }

}

export default {UserService, UserRoles}